import { CmsHubTopic } from '@oh-vcp/components-common';
import { useQuery, useQueryClient } from 'react-query';
import { apiGet } from './apiService';

const fetchCmsHubTopic = async (hubTopic: string): Promise<CmsHubTopic> => {
  return apiGet(`cms/context?hubTopic=${hubTopic}`);
};

const useCmsService = (hubTopic: string | undefined) => {
  const queryClient = useQueryClient();

  const result = useQuery({
    queryFn: () => fetchCmsHubTopic(hubTopic!),
    queryKey: ['useCmsService', hubTopic],
    enabled: !!hubTopic
  });

  const fetchQuery = async (topic: string): Promise<CmsHubTopic> => {
    return queryClient.fetchQuery(['useCmsService', topic], () => fetchCmsHubTopic(topic));
  };

  return {
    ...result,
    fetchQuery
  };
};

export default useCmsService;
